import * as React from 'react';
import CategoriesMobileMenu from '../CategoriesMobileMenu';
import { ICategoryContent } from 'src/model/category.model';
import locationIcon from 'src/assets/locationIcon';
import logout from 'src/assets/logoutIcon';
import accoutSetting from 'src/assets/accountSetting';
import cartIcon from 'src/assets/cartIcon';
import trackerIcon from 'src/assets/trackingIcon';
import orderIcon from 'src/assets/myOrderIcon';
import returnsIcon from 'src/assets/returnIcon';
import invoiceIcon from 'src/assets/invoiceIcon';
import UserModel from 'src/model/user.model';
import switchAccount from 'src/assets/switchUserSidemenu';
import returnsideIcon from 'src/assets/returnSidemenu';
import invoicesideIcon from 'src/assets/invoiceSidemenu';
import starIcon from 'src/assets/star-icon';
import MSRPToggle from '../MSRPToggle';
import RegionSwitch from 'src/components/RegionSwitch';
import Notifications from '../Notifications';
import notificationIcon from 'src/assets/notificationIcon';
import { isMobile } from 'src/utils/responsiveHelpers';




import ScrollBar from './components/Scrollbar/Scrollbar';

import './MobileMenu.scss';
import {
  goToHome,
  goToAccount,
  goToOrders,
  goToLocations,
  goToCart,
  goToTracking,
  cartUrl,
  ordersUrl,
  trackingUrl,
  locationsUrl,
  accountUrl,
  goToSwitchAccount,
  invoicesUrl,
  goToInvoices,
  returnsUrl,
  goToReturns,
  goToLists,
  listsUrl,
  returnsWarrantUrl,
  goToWarranty
} from 'src/utils/navigation';
import returnIcon from 'src/assets/returnIcon';
import myClaimsmobile from 'src/assets/images/myClaimsmobile';
import env from 'src/shared/env';

interface IMobileMenuProps {
  signout: () => void;
  isLoggedIn: boolean;
  mounted: boolean;
  categories: ICategoryContent[];
  getCategories: () => void;
  handleCloseMenu: () => void;
  handleCloseAll: () => void;
  menuTitle: string;
  userData: UserModel;
  getUserData: () => void;
  specialUser: string;
  accountHasChanged: boolean;
  changeActiveAccountFlag(flag: boolean): void;
  changeActiveAccount(newAccountId: string, clientIdentity: string): void;
  t?: any;
  showSwitchAccounts: boolean;
}

interface IMobileMenuState {
  show: boolean;
  showCategories: boolean;
  subMenuTitle: string;
  subcategories: any;
  accountId: string;
  name: string;
  sendKeyVal: string;
}

class MobileMenu extends React.Component<IMobileMenuProps, IMobileMenuState> {
  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      showCategories: true,
      subMenuTitle: '',
      subcategories: [],
      accountId:
        this.props.userData && this.props.userData.accountId
          ? this.props.userData.accountId
          : '',
      name:
        this.props.userData && this.props.userData.sub
          ? this.props.userData.sub
          : '',
       sendKeyVal:this.props.isLoggedIn ? 'YES' : 'NO'
    };
  }
  
  public handleOpenMobileMenu = () => {
    if (!this.state.show) {
      window.scrollTo(0, 0);
    }
    this.setState(prevState => ({
      show: !prevState.show
    }));
  };

  public handleCloseMobileMenu = () => {
    this.setState(prevState => ({
      show: false
    }));
    window.scrollTo(0, 0);
  };

  public handleOpenSubMenu = () => {
    this.setState({
      showCategories: true
    });
  };

  public handleCloseSubMenu = () => {
    this.setState({
      showCategories: false
    });
  };

  private logOut = () => {
    this.props.signout();
    this.handleCloseMobileMenu();
    goToHome();
  };

  private redirect = (callback: () => void) => {
    this.handleCloseMobileMenu();
    callback();
  };

  public render() {

    const isMob = isMobile();
    const { t } = this.props;
    if (this.state.show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return (
      <div className="rp-mobile-menu ">        
        <div
          onClick={e => this.handleOpenMobileMenu()}
          className="rp-mobile-menu--button"
        >
          {isMob && (<span className="topnotification">
            <Notifications handleCloseAll={this.handleCloseMobileMenu}/>
          </span>)}
          
          <button
            className={`rpds ${
              !this.state.show ? 'rpds-menu' : 'rpds-close'
            } open-menu-icon`}    
                    
          ><span className="visually-hidden-menu">Open main menu</span></button>
        </div>
        {this.state.show && (
          <div
            // className="rp-mobile-menu--toogle"
            className={
              this.props.isLoggedIn
                ? 'rp-mobile-menu--toogle'
                : 'rp-mobile-menu--toogle rp-side-menu-height'
            }
          >
            <div className="rp-menu-width">
              {this.props.isLoggedIn && (
                <div className="rp-mobile-menu--account">
                  <i className="rpds-user sidemenu--avatar" />
                  <div>
                    <p className="rp-user-name">{this.props.userData.name}</p>
                    <p className="rp-account-id">
                      {this.props.userData.accountId}
                      {this.props.showSwitchAccounts ? (
                        <img
                          src={switchAccount}
                          alt="icon"
                          className="rp-switchMenu-icon"
                          onClick={goToSwitchAccount}
                        />
                      ) : null}
                    </p>
                  </div>
                </div>
              )}
              <ScrollBar>
              <div key={this.state.sendKeyVal}>
                <CategoriesMobileMenu
                  mounted={this.state.showCategories}
                  handleCloseMenu={this.handleCloseSubMenu}
                  handleCloseAll={this.handleCloseMobileMenu}
                />
                <div className="menuSeparator" />
                <a className="rp-mobile-menu--menu-link-text rp-mobile-region-switcher-menu-link">
                  <div className="rp-mobile-menu--menu-link">
                    <RegionSwitch />
                  </div>
                </a>
                {this.props.isLoggedIn ? (
                  <a className="rp-mobile-menu--menu-link-text">
                    <div className="rp-mobile-menu--menu-link">
                      <MSRPToggle />
                    </div>
                  </a>
                ) : (
                  ''
                )}
                <a
                  href={locationsUrl()}
                  className="rp-mobile-menu--menu-link-text"
                >
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToLocations)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={locationIcon}
                        alt="Locations"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('common.locationTxt')}
                  </div>
                </a>
                <a
                  href={trackingUrl()}
                  className="rp-mobile-menu--menu-link-text"
                >
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToTracking)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={trackerIcon}
                        alt="Track order"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('common.trackOrder')}
                  </div>
                </a>
                <a
                  href={invoicesUrl()}
                  className="rp-mobile-menu--menu-link-text"
                >
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToInvoices)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={invoicesideIcon}
                        alt="My Invoice"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('menu.myInvoices')}
                  </div>
                </a>
                <a
                  href={returnsUrl()}
                  className="rp-mobile-menu--menu-link-text"
                >
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToReturns)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={returnsideIcon}
                        alt="My Returns"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('menu.myReturns')}
                  </div>
                </a>
                <a
                  href={returnsWarrantUrl()}
                  className="rp-mobile-menu--menu-link-text"
                >
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToWarranty)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={myClaimsmobile}
                        alt="My Claims"
                        className="sidemenu-icons"
                      />
                    </span>

                    {t('menu.myWarranty')}
                  </div>
                </a>
                <a
                  href={ordersUrl()}
                  className="rp-mobile-menu--menu-link-text"
                >
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToOrders)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={orderIcon}
                        alt="My Order"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('common.yourOrders')}
                  </div>
                </a>
                <a href={listsUrl()} className="rp-mobile-menu--menu-link-text">
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToLists)}
                  >
                    <span
                      className="menu-link-icon star rpds rpds-star-border"
                      style={{ transform: 'scale(1.5' }}
                    />

                    {/* </span> */}
                    {/* {t('myFavourites.breadCrumb')} */}
                    {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                      ? t('myFavourites.breadCrumbCA')
                      : t('myFavourites.breadCrumb')}
                  </div>
                </a>
                {this.props.isLoggedIn && (
                <span className="rp-mobile-menu--menu-link-text">
                  <div className="rp-mobile-menu--menu-link">
                  <span className="menu-link-icon">
                      <img
                        src={notificationIcon}
                        alt="Cart"
                        className="sidemenu-icons"
                      />
                    </span>
                    <Notifications 
                     handleCloseAll={this.handleCloseMobileMenu}/>
                  </div>
                </span>)}
                <a href={cartUrl()} className="rp-mobile-menu--menu-link-text">
                  <div
                    className="rp-mobile-menu--menu-link"
                    onClick={e => this.redirect(goToCart)}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={cartIcon}
                        alt="Cart"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('menu.cart')}
                  </div>
                </a>
                {this.props.isLoggedIn && <div className="menuSeparator" />}
                {this.props.isLoggedIn && (
                  <a
                    href={accountUrl()}
                    className="rp-mobile-menu--menu-link-text"
                  >
                    <div
                      className="rp-mobile-menu--menu-link"
                      onClick={e => this.redirect(goToAccount)}
                    >
                      <span className="menu-link-icon">
                        <img
                          src={accoutSetting}
                          alt="Accout Setting"
                          className="sidemenu-icons"
                        />
                      </span>
                      {t('account.accountSettings')}
                    </div>
                  </a>
                )}
                {this.props.isLoggedIn && (
                  <button
                    className="rp-mobile-menu--menu-link"
                    onClick={this.logOut}
                  >
                    <span className="menu-link-icon">
                      <img
                        src={logout}
                        alt="Logout"
                        className="sidemenu-icons"
                      />
                    </span>
                    {t('common.logOut')}
                  </button>
                )}
              </div>
              </ScrollBar>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MobileMenu;
